import React from "react";
import { InputNumber } from "antd";

import fieldIcon from "./fieldIcons";

/* Control only. Width comes from `.dp-form` in `component/detail-page.scss` — one rule for every
   control, not a per-renderer `style`, which is how these drifted into two widths per row. */
export default function NumberField({ field, value, onChange }) {
  return <InputNumber prefix={fieldIcon(field)} value={value ?? null} onChange={next => onChange(field.name, next ?? null)} />;
}
